import { Suspense, lazy } from "react";
import { Outlet } from "react-router-dom";
// auth
// layouts
import DashboardLayout from "../../layouts/dashboard";
// components
import { LoadingScreen } from "../../components/loading-screen";
// import UserView from '../../sections/user/view';
// import PredictionView from '../../sections/prediction/view';
// import ChangePasswordView from '../../sections/change-password/view';

// ----------------------------------------------------------------------

const DashboardPage = lazy(
  () => import("../../pages/dashboard/dashboard-page")
);
const UserPage = lazy(() => import("../../pages/dashboard/user"));
const HistoryPage = lazy(() => import("../../pages/dashboard/history"));
const PredictionPage = lazy(() => import("../../pages/dashboard/prediction"));
const ContactPage = lazy(() => import("../../pages/dashboard/contact-us"));
const ChangePasswordPage = lazy(
  () => import("../../pages/dashboard/change-password")
);

// ----------------------------------------------------------------------

export const dashboardRoutes = [
  {
    path: "/dashboard",
    element: (
      <DashboardLayout>
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </DashboardLayout>
    ),
    children: [{ element: <DashboardPage />, index: true }],
  },
  {
    path: "user",
    element: (
      <DashboardLayout>
        <Suspense fallback={<LoadingScreen />}>
          <UserPage />
        </Suspense>
      </DashboardLayout>
    ),
  },
  {
    path: "prediction",
    element: (
      <DashboardLayout>
        <Suspense fallback={<LoadingScreen />}>
          <PredictionPage />
        </Suspense>
      </DashboardLayout>
    ),
  },
  {
    path: "history",
    element: (
      <DashboardLayout>
        <Suspense fallback={<LoadingScreen />}>
          <HistoryPage />
        </Suspense>
      </DashboardLayout>
    ),
  },
  {
    path: "contactus",
    element: (
      <DashboardLayout>
        <Suspense fallback={<LoadingScreen />}>
          <ContactPage />
        </Suspense>
      </DashboardLayout>
    ),
  },
  {
    path: "change-password",
    element: (
      <DashboardLayout>
        <Suspense fallback={<LoadingScreen />}>
          <ChangePasswordPage />
        </Suspense>
      </DashboardLayout>
    ),
  },
];
